import View from 'cdna/core/view';
import FaqEntryView from './faqEntryView.js';
import FaqLinkView from './faqLinkView.js';
import markup from './faqPageView.html';

import _ from 'underscore';
import $ from 'jquery';
import 'jquery-scrollto';

export default View.extend({    
    el: markup,
    bindings: {   
        'Id': 'attr data-nav',
        'Entries .list': 'collection faqBindings faqBindings',
        'Entries .toc': 'collection faqLinkBindings faqLinkBindings',
    },
    faqBindings: {            
        itemView: FaqEntryView
    },
    faqLinkBindings: {
        itemView: FaqLinkView
    },
    events: {
        'click .faq-toc': 'scrollToFaq',
        'click .toggle-all-faqs .expand': 'expandAllFaqs',
        'click .toggle-all-faqs .collapse': 'collapseAllFaqs',
    },   
    scrollToFaq(ev) {
        var el = $(ev.currentTarget);
        var modelId = el.attr('name');
        var faqEntry = this.model.get('Entries').get(modelId);
        faqEntry.set('toggled', true);

        var el = this.$('.faq-entry[name=' + modelId + ']').children().first();
        _.delay(() => {
            el.ScrollTo();
        }, 200);
    },
    expandAllFaqs() {
        this.model.get('Entries').each(function(e) {
            e.set('toggled', true);
        });
    },
    collapseAllFaqs() {
        this.model.get('Entries').each(function(e) {
            e.set('toggled', false);
        });
    },
});


/** WEBPACK FOOTER **
 ** ./client/faq/faqPageView.js
 **/